import {
    take,
    put,
    call,
    all,
    takeEvery,
} from 'redux-saga/effects';
import { dropdownMasterActions as actions, notificationActions } from '../actions';
import { dropdownMasterService } from '../services';


/* Get Filtered Dropdown Data Sagas */
function* handleGetFilteredDropdownDataRequest() {
    const action = yield take(actions.getFilteredDropdownDataRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(dropdownMasterService.getFilteredDropdownData, dataParams);

        if (res.isError) {
            yield put(actions.getFilteredDropdownDataError(res));

        } else {
            yield put(actions.getFilteredDropdownDataSuccess(res));
        }

    } catch (error) {
        yield put(actions.getFilteredDropdownDataError());
    }
}

/* Add Dropdown Data Sagas */
function* handleAddDropdownDataRequest() {
    const action = yield take(actions.addDropdownDataRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(dropdownMasterService.addDropdownData, dataParams);

        if (res.isError) {
            yield put(actions.addDropdownDataError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

        } else {
            yield put(actions.addDropdownDataSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }

    } catch (error) {
        yield put(actions.addDropdownDataError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get All Dropdown Data Sagas */
function* handleGetAllDropdownDataRequest() {
    const action = yield take(actions.getAllDropdownDataRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(dropdownMasterService.getAllDropdownData, dataParams);

        if (res.isError) {
            yield put(actions.getAllDropdownDataError(res));

        } else {
            yield put(actions.getAllDropdownDataSuccess(res));
        }

    } catch (error) {
        yield put(actions.getAllDropdownDataError());
    }
}

/* Delete Dropdown Data Sagas */
function* handleDeleteDropdownDataRequest() {
    const action = yield take(actions.deleteDropdownDataRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(dropdownMasterService.deleteDropdownData, dataParams);
        if (res.isError) {
            yield put(actions.deleteDropdownDataError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.deleteDropdownDataSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.deleteDropdownDataError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Update Dropdown Data Sagas */
function* handleUpdateDropdownDataRequest() {
    const action = yield take(actions.updateDropdownDataRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(dropdownMasterService.updateDropdownData, dataParams);

        if (res.isError) {
            yield put(actions.updateDropdownDataError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.updateDropdownDataSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.updateDropdownDataError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get Dropdown Constant Data Sagas */
function* handleGetDropdownMasterConstantDataRequest() {
    const action = yield take(actions.getDropdownMasterConstantDataRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(dropdownMasterService.getDropdownMasterConstantData, dataParams);

        if (res.isError) {
            yield put(actions.getDropdownMasterConstantDataError(res));
        } else {
            yield put(actions.getDropdownMasterConstantDataSuccess(res));
        }
    } catch (error) {
        yield put(actions.getDropdownMasterConstantDataError());
    }
}


/* Get Dropdown Constant Data Sagas */
function* handleAddMasterDropdownCategoryRequest() {
    const action = yield take(actions.addMasterDropdownCategoryRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(dropdownMasterService.addMasterDropdownCategory, dataParams);

        if (res.isError) {
            yield put(actions.addMasterDropdownCategoryError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.addMasterDropdownCategorySuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.addMasterDropdownCategoryError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get Dropdown Constant Data Sagas */
function* handleGetMasterDropdownCategoryRequest() {
    const action = yield take(actions.getMasterDropdownCategoryRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(dropdownMasterService.getMasterDropdownCategory, dataParams);

        if (res.isError) {
            yield put(actions.getMasterDropdownCategoryError(res));
        } else {
            yield put(actions.getMasterDropdownCategorySuccess(res));
        }
    } catch (error) {
        yield put(actions.getMasterDropdownCategoryError());
    }
}

/* Get All Dropdown Constant Data Sagas */
function* handleGetAllMasterDropdownCategoryRequest() {
    const action = yield take(actions.getAllMasterDropdownCategoryRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(dropdownMasterService.getAllMasterDropdownCategory, dataParams);

        if (res.isError) {
            yield put(actions.getAllMasterDropdownCategoryError(res));
        } else {
            yield put(actions.getAllMasterDropdownCategorySuccess(res));
        }
    } catch (error) {
        yield put(actions.getAllMasterDropdownCategoryError());
    }
}

/* Get Dropdown Constant Data Sagas */
function* handleUpdateMasterDropdownCategoryRequest() {
    const action = yield take(actions.updateMasterDropdownCategoryRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(dropdownMasterService.updateMasterDropdownCategory, dataParams);

        if (res.isError) {
            yield put(actions.updateMasterDropdownCategoryError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.updateMasterDropdownCategorySuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.updateMasterDropdownCategoryError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

function* handleDeleteMasterDropdownCategoryRequest() {
    const action = yield take(actions.deleteMasterDropdownCategoryRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(dropdownMasterService.deleteMasterDropdownCategory, dataParams);

        if (res.isError) {
            yield put(actions.deleteMasterDropdownCategoryError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.deleteMasterDropdownCategorySuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.deleteMasterDropdownCategoryError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}


/* Add Designation Sagas */
function* handleCreateQuestionRequest() {
    const action = yield take(actions.createQuestionRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(dropdownMasterService.createQuestion, dataParams);
        if (res.isError) {
            yield put(actions.createQuestionError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.createQuestionSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.createQuestionError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get All Designation Sagas */
function* handleGetQuestionRequest() {
    const action = yield take(actions.getQuestionRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(dropdownMasterService.getQuestion, dataParams);
        if (res.isError) {
            yield put(actions.getQuestionError(res));

        } else {
            yield put(actions.getQuestionSuccess(res));
        }

    } catch (error) {
        yield put(actions.getQuestionError());
    }
}

/* Get Designation By Department Sagas */
function* handleGetAllQuestionRequest() {
    const action = yield take(actions.getAllQuestionRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(dropdownMasterService.getAllQuestion, dataParams);
        if (res.isError) {
            yield put(actions.getAllQuestionError(res));

        } else {
            yield put(actions.getAllQuestionSuccess(res));
        }

    } catch (error) {
        yield put(actions.getAllQuestionError());
    }
}

/* Update Designation Sagas */
function* handleUpdateQuestionRequest() {
    const action = yield take(actions.updateQuestionRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(dropdownMasterService.updateQuestion, dataParams);
        if (res.isError) {
            yield put(actions.updateQuestionError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.updateQuestionSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.updateQuestionError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}
/* Delete Designation Sagas */
function* handleDeleteQuestionRequest() {
    const action = yield take(actions.deleteQuestionRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(dropdownMasterService.deleteQuestion, dataParams);
        if (res.isError) {
            yield put(actions.deleteQuestionError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.deleteQuestionSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.deleteQuestionError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Delete Designation Sagas */
function* handleGetDropDownMasterRequest() {
    const action = yield take(actions.getDropDownMasterRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(dropdownMasterService.getDropDownMaster, dataParams);
        if (res.isError) {
            yield put(actions.getDropDownMasterError(res));
        } else {
            yield put(actions.getDropDownMasterSuccess(res));
        }
    } catch (error) {
        yield put(actions.getDropDownMasterError());
    }
}


/* -----------Watchers------------- */
function* handleGetFilteredDropdownDataWatcher() {
    yield takeEvery(
        actions.getFilteredDropdownDataRequest,
        handleGetFilteredDropdownDataRequest,
    );
}

function* handleAddDropdownDataWatcher() {
    yield takeEvery(
        actions.addDropdownDataRequest,
        handleAddDropdownDataRequest,
    );
}

function* handleGetAllDropdownDataWatcher() {
    yield takeEvery(
        actions.getAllDropdownDataRequest,
        handleGetAllDropdownDataRequest,
    );
}

function* handleDeleteDropdownDataWatcher() {
    yield takeEvery(
        actions.deleteDropdownDataRequest,
        handleDeleteDropdownDataRequest,
    );
}

function* handleUpdateDropdownDataWatcher() {
    yield takeEvery(
        actions.updateDropdownDataRequest,
        handleUpdateDropdownDataRequest,
    );
}

function* handleGetDropdownMasterConstantDataWatcher() {
    yield takeEvery(
        actions.getDropdownMasterConstantDataRequest,
        handleGetDropdownMasterConstantDataRequest,
    );
}

function* handleAddMasterDropdownCategoryWatcher() {
    yield takeEvery(
        actions.addMasterDropdownCategoryRequest,
        handleAddMasterDropdownCategoryRequest,
    );
}

function* handleUpdateMasterDropdownCategoryWatcher() {
    yield takeEvery(
        actions.updateMasterDropdownCategoryRequest,
        handleUpdateMasterDropdownCategoryRequest,
    );
}

function* handleGetMasterDropdownCategoryWatcher() {
    yield takeEvery(
        actions.getMasterDropdownCategoryRequest,
        handleGetMasterDropdownCategoryRequest,
    );
}

function* handleGetAllMasterDropdownCategoryWatcher() {
    yield takeEvery(
        actions.getAllMasterDropdownCategoryRequest,
        handleGetAllMasterDropdownCategoryRequest,
    );
}

function* handleDeleteMasterDropdownCategoryWatcher() {
    yield takeEvery(
        actions.deleteMasterDropdownCategoryRequest,
        handleDeleteMasterDropdownCategoryRequest,
    );
}

function* handleCreateQuestionWatcher() {
    yield takeEvery(
        actions.createQuestionRequest,
        handleCreateQuestionRequest,
    );
}

function* handleGetQuestionWatcher() {
    yield takeEvery(
        actions.getQuestionRequest,
        handleGetQuestionRequest,
    );
}

function* handleGetAllQuestionWatcher() {
    yield takeEvery(
        actions.getAllQuestionRequest,
        handleGetAllQuestionRequest,
    );
}

function* handleUpdateQuestionWatcher() {
    yield takeEvery(
        actions.updateQuestionRequest,
        handleUpdateQuestionRequest,
    );
}

function* handleDeleteQuestionWatcher() {
    yield takeEvery(
        actions.deleteQuestionRequest,
        handleDeleteQuestionRequest,
    );
}

function* handleGetDropDownMasterWatcher() {
    yield takeEvery(
        actions.getDropDownMasterRequest,
        handleGetDropDownMasterRequest,
    );
}

function* rootDropdownMasterSaga() {
    yield all([
        handleGetFilteredDropdownDataRequest(),
        handleGetFilteredDropdownDataWatcher(),

        handleAddDropdownDataRequest(),
        handleAddDropdownDataWatcher(),


        handleGetAllDropdownDataRequest(),
        handleGetAllDropdownDataWatcher(),

        handleDeleteDropdownDataRequest(),
        handleDeleteDropdownDataWatcher(),

        handleUpdateDropdownDataRequest(),
        handleUpdateDropdownDataWatcher(),

        handleGetDropdownMasterConstantDataRequest(),
        handleGetDropdownMasterConstantDataWatcher(),

        handleAddMasterDropdownCategoryRequest(),
        handleAddMasterDropdownCategoryWatcher(),

        handleUpdateMasterDropdownCategoryRequest(),
        handleUpdateMasterDropdownCategoryWatcher(),

        handleGetMasterDropdownCategoryRequest(),
        handleGetMasterDropdownCategoryWatcher(),

        handleGetAllMasterDropdownCategoryRequest(),
        handleGetAllMasterDropdownCategoryWatcher(),

        handleDeleteMasterDropdownCategoryRequest(),
        handleDeleteMasterDropdownCategoryWatcher(),

        handleCreateQuestionRequest(),
        handleCreateQuestionWatcher(),

        handleGetQuestionRequest(),
        handleGetQuestionWatcher(),

        handleGetAllQuestionRequest(),
        handleGetAllQuestionWatcher(),

        handleUpdateQuestionRequest(),
        handleUpdateQuestionWatcher(),

        handleDeleteQuestionRequest(),
        handleDeleteQuestionWatcher(),

        handleGetDropDownMasterRequest(),
        handleGetDropDownMasterWatcher(),
    ]);
}

export default rootDropdownMasterSaga;